import { AuthStatus } from 'feature/auth/redux/authSlice'
import { ClientType } from 'feature/user/types'

const REFRESH_TOKEN = 'refreshToken'
const AUTH_STATUS = 'authStatus'
const CLIENT_TYPE = 'clientType'

// eslint-disable-next-line max-len
export const getAuthRefreshAccessToken = () =>
  localStorage.getItem(REFRESH_TOKEN)

export const setAuthRefreshAccessToken = (token: string | null) => {
  if (token) {
    localStorage.setItem(REFRESH_TOKEN, token)
  } else localStorage.removeItem(REFRESH_TOKEN)
}

export const setAuthStatus = (status: AuthStatus) => {
  localStorage.setItem(AUTH_STATUS, status)
}

export const getAuthStatus = () => {
  const status = localStorage.getItem(AUTH_STATUS)
  if (status) {
    return status as AuthStatus
  } else {
    return AuthStatus.guest
  }
}

export const setClientType = (type: ClientType) => {
  localStorage.setItem(CLIENT_TYPE, type)
}

export const getClientType = (): ClientType | null => {
  const type = localStorage.getItem(CLIENT_TYPE)
  return type as ClientType | null
}

export const clearClientType = () => {
  localStorage.removeItem(CLIENT_TYPE)
}
